/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebox_Unknownuser2Inputs */

const en_profilebox_unknownuser2 = /** @type {(inputs: Profilebox_Unknownuser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown user`)
};

const de_profilebox_unknownuser2 = /** @type {(inputs: Profilebox_Unknownuser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Benutzer`)
};

/**
* | output |
* | --- |
* | "Unknown user" |
*
* @param {Profilebox_Unknownuser2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebox_unknownuser2 = /** @type {((inputs?: Profilebox_Unknownuser2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebox_Unknownuser2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebox_unknownuser2(inputs)
	return de_profilebox_unknownuser2(inputs)
});
export { profilebox_unknownuser2 as "profileBox_unknownUser" }